export const CONNECT_MOBILE_PROFILE_SUCCESS = 'Processed'

function readConnectMobileProfileValue(response) {
  if (response === true) {
    return CONNECT_MOBILE_PROFILE_SUCCESS
  }

  if (typeof response === 'string') {
    return response
  }

  const value = response?.value ?? response?.Value

  if (value === true) {
    return CONNECT_MOBILE_PROFILE_SUCCESS
  }

  if (typeof value === 'string') {
    return value
  }

  if (value?.status) {
    return value.status
  }

  return value
}

export function getConnectMobileProfileResponseValue(response) {
  return readConnectMobileProfileValue(response)
}

export function isConnectMobileProfileSuccess(response) {
  const responseValue = readConnectMobileProfileValue(response)

  if (responseValue === true) {
    return true
  }

  if (typeof responseValue === 'string') {
    return responseValue === CONNECT_MOBILE_PROFILE_SUCCESS
  }

  return false
}
